import React from 'react';
import ModalBox from '../../components/Common/ModalBox';
import Button from '../../components/Common/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function ModalPromo({
    inputPromo,
    productData,
    msgPromo,
    setFixPromo,
    isModalCekPromo,
    toggleModalCekPromo,
    isModalCekPromo1,
    toggleModalCekPromo1,
    isModalDescription,
    toggleModalDescription
}) {
    return (
        <>
            <ModalBox active={isModalCekPromo} onClose={toggleModalCekPromo}>
                <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-center">
                        <img className="flex w-[50%]"
                            src={require("../../assets/images/promonotfound.png")}
                            alt="promo not found"
                        />
                    </div>
                    <div className="flex flex-col">
                        <span
                            className={` text-lg font-semibold `}
                        >
                            Yahh, Kode Gift Kamu <span className={`text-[#F44336]  `}>Tidak Valid</span>
                        </span>
                        <span
                            className={` text-sm `}
                        >
                            Silahkan masukan kode gift yang benar, atau lakukan Pembelian
                        </span>
                    </div>
                    <Button
                        initialValue="Oke"
                        type="fill"
                        className="bg-[#22BDE2] text-darkColor w-full "
                        onClick={() => {
                            toggleModalCekPromo();
                        }}
                    />
                </div>
            </ModalBox>

            <ModalBox active={isModalCekPromo1} onClose={toggleModalCekPromo1}>
                <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-center">
                        <img className="flex w-[50%]"
                            src={require("../../assets/images/promofound.png")}
                            alt="promo not found"
                        />
                    </div>
                    <div className="flex flex-col">
                        <span
                            className={` text-lg font-semibold `}
                        >
                            Selamat, Kode Gift Kamu <span className={`text-[#4CAF50]  `}>Verified</span>
                        </span>
                        <span
                            className={` text-sm `}
                        >
                            Silahkan klik <b>Konfirmasi Redeem</b> untuk mengambil reward giftmu
                        </span>
                    </div>
                    <div className="flex flex-col p-3 gap-2 rounded-lg shadow-inner">
                        <div className="flex flex-row gap-2 items-center">
                            <LazyLoadImage
                                src={productData.gambar}
                                alt={productData.nama}
                                className=" object-cover  h-12 aspect-square rounded-lg"
                                effect="blur"
                            />
                            <div className="flex flex-col">
                                <span
                                    className={` text-base font-medium `}
                                >
                                    {productData.nama}
                                </span>
                            </div>
                        </div>
                        <div className="flex flex-row items-center">
                            <span
                                className={` text-base flex-1`}
                            >
                                Kode Redeem
                            </span>
                            <span
                                className={` text-base font-semibold flex-1 text-right`}
                            >
                                {inputPromo}
                            </span>
                        </div>
                        <div className="flex flex-row items-center">
                            <span
                                className={` text-base flex-1`}
                            >
                                Batas Periode Redeem
                            </span>
                            <span
                                className={` text-base font-semibold flex-1 text-right`}
                            >
                                17-01-2024 23:59 (belum ada)
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-col p-3 gap-2 rounded-lg shadow-inner">
                        <span
                            className={` text-base flex-1`}
                        >
                            Pesan
                        </span>
                        <span
                            className={` text-base font-semibold flex-1 `}
                        >
                            {msgPromo}
                        </span>
                    </div>
                    <div className="flex flex-row gap-2">
                        <Button
                            initialValue="Batalkan"
                            type="fill"
                            color="bg-[#CCCCCC] w-full "
                            onClick={() => {
                                toggleModalCekPromo1();
                            }}
                        />
                        <Button
                            initialValue="Konfirmasi Redeem"
                            type="fill"
                            color="bg-[#22BDE2] w-full "
                            onClick={() => {
                                toggleModalCekPromo1();
                                setFixPromo(inputPromo);
                            }}
                        />
                    </div>
                </div>
            </ModalBox>

            <ModalBox active={isModalDescription} onClose={toggleModalDescription}>
                <div className="flex flex-col gap-3">
                    <span
                        className={` text-lg font-semibold `}
                    >
                        Tutorial Singkat
                    </span>
                    <div className="flex flex-row gap-2 items-center">
                        <LazyLoadImage
                            src={productData.gambar}
                            alt={productData.nama}
                            className=" object-cover  h-12 aspect-square rounded-lg"
                            effect="blur"
                        />
                        <div className="flex flex-col">
                            <span
                                className={` text-base font-medium `}
                            >
                                {productData.nama}
                            </span>
                            <span
                                className={` text-sm `}
                            >
                                Baca dengan teliti dan pahami sebelum anda melakukan transaksi
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-col p-3 rounded-lg shadow-inner bg-lightColor dark:bg-darkColor">
                        <div className="prose">
                            <div
                                dangerouslySetInnerHTML={{ __html: productData.tutorial_singkat }}
                                className={` text-base `}
                            />
                        </div>
                    </div>
                    <Button
                        initialValue="Paham"
                        type="fill"
                        className="bg-[#22BDE2] w-full text-darkColor"
                        onClick={() => {
                            toggleModalDescription();
                        }}
                    />
                </div>
            </ModalBox>
        </>
    );
}

export default ModalPromo;
